import { Tooltip } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div id="Footer" className="gpt3__footer section__padding">
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">Start writing smarter today — it's free.</h1>
      </div>

      <div onClick={() => navigate("/authentication/sign-up")} className="gpt3__footer-btn">
        <p>Create free account</p>
      </div>

      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <h1 style={{ color: "white" }}>WriteAI</h1>
          <p>
            WriteAI, <br /> All Rights Reserved
          </p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>🔗 Product</h4>
          <p onClick={() => navigate("/authentication/sign-up")} style={{ cursor: "pointer" }}>Get Started</p>
          <p onClick={() => navigate("/authentication/sign-in")} style={{ cursor: "pointer" }}>Sign In</p>
          <Tooltip placement="top-start" title="Coming soon">
            <p style={{ cursor: "pointer" }}>Pricing</p>
          </Tooltip>
        </div>
        <Tooltip placement="top-start" title="Coming soon">
          <div className="gpt3__footer-links_div">
            <h4>🏢 Company</h4>
            <p>Terms &amp; Conditions</p>
            <p>Privacy Policy</p>
          </div>
        </Tooltip>
        <div className="gpt3__footer-links_div">
          <h4>
            <span role="img" aria-label="waving hand">👋</span> Get in touch
          </h4>
          <p>info@finishessay.com</p>
        </div>
      </div>

      <div className="gpt3__footer-copyright">
        <p>@{new Date().getFullYear()} WriteAI. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
